module.exports = __webpack_public_path__ + "img/monitoring-bus-yellow.fa2018e8.svg";